import { CoinBadgeV2 } from "@components/CoinBadgeV2";
import { SelectableCoinBadge } from "@components/SelectableCoinBadge";
import { PricesModal } from "@components/modals/PricesModal";
import { useAccount } from "@contexts/AccountContext";
import { useCoins } from "@contexts/CoinsContext";
import { MsgExecuteContract } from "@goblinhunt/cosmes/client";
import useAlert from "@hooks/AlertHook";
import { errorPromise, useApi } from "@hooks/ApiHook";
import useModal from "@hooks/ModalHook";
import { useTxModal } from "@hooks/TxModalHook";
import { useWasmQuery } from "@hooks/WasmQueryHook";
import { useWasmX } from "@hooks/WasmXHook";
import { CollectionResponse, NftResponse } from "baaanggg";
import { useWallet } from "@providers/wallet.provider";
import React, { useEffect, useState } from "react";
import { AssetRequest, MessageDetail } from "wasmx";
import { TxInfo } from "@terra-money/terra.js";
import { useParams } from "react-router-dom";

export interface Props {
  nft: NftResponse;
  collection: CollectionResponse;
  onBought: () => void;
}

export function NftBuyItemBox({ nft, collection, onBought }: Props) {
  const wasmx = useWasmX();
  const alert = useAlert();
  const { getCoin } = useCoins();
  const txModal = useTxModal();
  const { address, wallet } = useWallet();
  const { collectionQuery, tokenId } = useParams();

  const [payment, setPayment] = useState<string>();
  const { refresh: refreshNft } = useApi((api) =>
    api.item.nft(collectionQuery!, tokenId!)
  );

  const { data: sellInfo, refresh: refreshSellInfo } = useWasmQuery(
    (wasmx) => {
      if (!collection) return errorPromise();
      return wasmx.collection.query.sellInfo({
        contract: collection.collectionContract,
        data: {
          token_id: nft.tokenId,
        },
      });
    },
    [collection]
  );

  const onBuy = async () => {
    try {
      if (!payment) throw new Error("Please select payment type");

      const coin = getCoin(payment);
      const asset = sellInfo!.prices.find(
        (e) =>
          e.coin?.denom === coin?.denom ||
          e.token?.address === coin?.cw20Address
      )!;
      const msgs: MsgExecuteContract<any>[] = [];
      console.log(sellInfo!.prices);
      console.log(asset);
      console.log(address);
      const payload = {
        buy: { token_id: nft.tokenId, buyer_address: address },
      };
      console.log(asset);
      const json = JSON.stringify(payload);
      const b64 = Buffer.from(json, "utf8").toString("base64");

      if (Object.keys(asset)[0] === "token") {
        console.log(asset.token?.address);

        msgs.push(
          new MsgExecuteContract({
            sender: address ?? "",
            contract: asset.token?.address ?? "",
            msg: {
              send: {
                contract: collection.collectionContract,
                amount: asset.token?.amount,
                msg: b64,
              },
            },
            funds: [],
          })
        );
      } else {
        msgs.push(
          new MsgExecuteContract({
            contract: collection.collectionContract,
            sender: address ?? "",
            msg: payload,
            funds: [
              {
                amount: asset.coin?.amount.toString() ?? "0",
                denom: asset.coin?.denom ?? "",
              },
            ],
          })
        );
      }

      const data = await new Promise<string>((onSuccess, onError) =>
        txModal.show(msgs, `Buy NFT '${nft.name}'`, {
          onSuccess: async (tx) => {
            try {
              alert.loading("Sign Tx");

              await wallet!.pollTx(tx, {
                maxAttempts: 120_000,
                intervalSeconds: 15,
              });
            } catch (e) {
              // kalau mau, tampilkan warning tapi lanjut refresh
              console.warn("poll failed", e);
            }
            alert.success("the NFT was bought");
            onBought();
          },
          onError,
        })
      );
      console.log(data);
    } catch (e) {
      if (e instanceof Error) alert.failed(e.message);
      else console.error(e);
    }
  };

  if (sellInfo)
    return (
      <div className="mb-5 rounded-2lg border border-jacarta-100 bg-white p-8 dark:border-gray-400 dark:bg-gray-900">
        <div className="flex flex-wrap">
          {sellInfo.prices.map((price) => {
            const coin = getCoin(
              price.coin?.denom ?? price.token?.address ?? ""
            );

            return (
              <div className="mb-2.5 mr-2.5" key={coin?.id}>
                <SelectableCoinBadge
                  onSelected={(coinId) =>
                    setPayment(coinId === payment ? undefined : coinId)
                  }
                  isSelected={coin?.id == payment}
                  amount={Number(price.coin?.amount ?? price.token?.amount)}
                  coinId={coin?.id ?? ""}
                />
              </div>
            );
          })}
        </div>

        <button
          onClick={onBuy}
          className="inline-block w-full rounded-full bg-jacarta-500 px-8 py-3 text-center font-semibold text-white transition-all hover:bg-jacarta-600"
        >
          Buy
        </button>
      </div>
    );

  return <></>;
}
